import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WindowTitle = _resolveComponent("WindowTitle")!
  const _component_ChangingNumber = _resolveComponent("ChangingNumber")!
  const _component_White = _resolveComponent("White")!
  const _component_WindowContent = _resolveComponent("WindowContent")!
  const _component_Window = _resolveComponent("Window")!

  return (_openBlock(), _createBlock(_component_Window, { class: "dashboard-transmitters" }, {
    default: _withCtx(() => [
      _createVNode(_component_WindowTitle, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Broadcasts ")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_WindowContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, [
                  _createElementVNode("a", { href: "https://chaos.social/@freeside" }, "https://chaos.social/@freeside")
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_White, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ChangingNumber, {
                        min: 6.1,
                        max: 6.2,
                        precision: 1
                      }),
                      _cache[1] || (_cache[1] = _createTextVNode(" MW "))
                    ]),
                    _: 1,
                    __: [1]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                  _createElementVNode("a", { href: "https://github.com/FREESIDE-HOLDINGS-LTD" }, "https://github.com/FREESIDE-HOLDINGS-LTD")
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_White, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ChangingNumber, {
                        min: 5.1,
                        max: 5.5,
                        precision: 1
                      }),
                      _cache[3] || (_cache[3] = _createTextVNode(" MW "))
                    ]),
                    _: 1,
                    __: [3]
                  })
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}